module.exports = __webpack_public_path__ + "static/media/arrow-to-down.3332a8af.svg";